(ns livefeed.report-modal
  (:require
   [cljs.core.async :refer [<! go]]
   [livefeed.i18n :refer [translate]]
   [livefeed.properties :as properties]
   [livefeed.quote :refer [message-quote]]
   [livefeed.feed :as feed]
   [livefeed.modal :as modal]
   [livefeed.api :as api]
   [livefeed.toast :as toast]
   [reagent.core :refer [after-render atom]]
   ["@yleisradio/yds-components-react" :refer [Select Notification Textarea TextInput Checkbox Button]]))

(def dsa-categories
  ["STATEMENT_CATEGORY_OTHER_VIOLATION_TC"
   "STATEMENT_CATEGORY_ILLEGAL_OR_HARMFUL_SPEECH"
   "STATEMENT_CATEGORY_NEGATIVE_EFFECTS_ON_CIVIC_DISCOURSE_OR_ELECTIONS"
   "STATEMENT_CATEGORY_VIOLENCE"
   "STATEMENT_CATEGORY_RISK_FOR_PUBLIC_SECURITY"
   "STATEMENT_CATEGORY_CYBER_VIOLENCE"
   "STATEMENT_CATEGORY_CYBER_VIOLENCE_AGAINST_WOMEN"
   "STATEMENT_CATEGORY_SELF_HARM"
   "STATEMENT_CATEGORY_CONSUMER_INFORMATION"
   "STATEMENT_CATEGORY_DATA_PROTECTION_AND_PRIVACY_VIOLATIONS"
   "STATEMENT_CATEGORY_UNSAFE_AND_PROHIBITED_PRODUCTS"
   "STATEMENT_CATEGORY_ANIMAL_WELFARE"
   "STATEMENT_CATEGORY_PROTECTION_OF_MINORS"
   "STATEMENT_CATEGORY_SCAMS_AND_FRAUD"
   "STATEMENT_CATEGORY_INTELLECTUAL_PROPERTY_INFRINGEMENTS"])

(def dsa-category-empty "EMPTY")

(defn scroll-to-element [element-id]
  (when-let [element (js/document.getElementById element-id)]
    (.scrollIntoView element #js {:behavior "smooth"})))

(defn component []
  (let [status (atom nil)
        reason (atom dsa-category-empty)
        argument (atom "")
        email (atom "")
        confirm (atom false)
        errors (atom {:email nil :argument nil :reason nil :confirm nil})
        validate (fn []
                   (reset! errors {})
                   (cond
                     (= @reason dsa-category-empty)
                     (do (swap! errors assoc :reason (translate :report :reason-required))
                         (scroll-to-element "report-reason"))
                     (> (count @argument) 400)
                     (do (swap! errors assoc :argument (translate :report :argument-too-long))
                         (scroll-to-element "report-argument"))
                     (and (seq @email)
                          (not (.includes @email "@")))
                     (do (swap! errors assoc :email (translate :report :email-format))
                         (scroll-to-element "report-email"))
                     (not @confirm)
                     (do (swap! errors assoc :confirm (translate :report :confirm-required))
                         (scroll-to-element "report-confirm"))))
        on-submit #(do
                     (.preventDefault %)
                     (validate)
                     (when (empty? @errors)
                       (reset! status :loading)
                       (go
                         (let [res (<! (api/post-report {:comment-id (:id @feed/reported-message)
                                                         :argument @argument
                                                         :reason @reason
                                                         :email @email
                                                         :language (get {:fi "fi" :sv "sv" :en "en"}
                                                                        (properties/get-property :language)
                                                                        "fi")}))]
                           (case res
                             :error-message-rejected (do (reset! status :error-message-rejected)
                                                         (after-render (fn [] (scroll-to-element "report-submit"))))
                             false (do (reset! status :error)
                                       (after-render (fn [] (scroll-to-element "report-submit"))))
                             (do (toast/notify! {:level "success"
                                                 :hideCloseButton true
                                                 :children (translate :report :received)})
                                 (reset! feed/reported-message nil)))))))]
    (fn []
      [modal/component {:class :report-modal :on-close (fn [] (reset! feed/reported-message nil))}
       [:h1.report-modal__header (translate :report :header)]
       [:div.report-modal__scroll-container
        [message-quote @feed/reported-message]
        [:form.report-modal__scroll-container__form
         {:on-submit on-submit}
         [:> Select {:label (translate :report :reason)
                     :id "report-reason"
                     :value @reason
                     :on-change #(reset! reason (-> % .-target .-value))
                     :description (translate :report :reason-description)
                     :error-message (get @errors :reason)
                     :items (for [category (conj dsa-categories dsa-category-empty)]
                              {:value category
                               :label (translate :report :dsa (keyword category))})}]
         [:> Textarea {:id "report-argument"
                       :label (translate :report :argument)
                       :value @argument
                       :on-change #(reset! argument (-> % .-target .-value))
                       :placeholder ""
                       :rows 4
                       :error-message (get @errors :argument)
                       :label-options {:optional-label (str "(" (translate :report :optional) ")")}}]
         [:> TextInput {:id "report-email"
                        :label (translate :report :email)
                        :value @email
                        :on-change #(reset! email (-> % .-target .-value))
                        :error-message (get @errors :email)
                        :label-options {:optional-label (str "(" (translate :report :optional) ")")}
                        :description (translate :report :email-description)}]
         [:div {:style {:position "relative"}} ;; style is bugfix for YDS input alignment issue inside scrollable container
          [:> Checkbox {:id "report-confirm"
                        :label (translate :report :confirm)
                        :value @confirm
                        :on-change #(reset! confirm (-> % .-target .-checked))
                        :error (get @errors :confirm)}]]
         (when (= @status :error) [:> Notification {:level "error"} (translate :report :error)])
         (when (= @status :error-message-rejected) [:> Notification {:level "warning"} (translate :report :error-message-rejected)])
         [:> Button {:id "report-submit"
                     :type "submit"
                     :full-width true
                     :disabled (not= @status nil)
                     :is-disabled (not= @status nil)}
          (translate :report :submit)]]]])))
